import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
// eslint-disable-next-line
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import GitHubCalendar from 'react-github-calendar';
import Works from "../components/homepage/works";

import "./styles/about.css";

import Particles from '../components/particles/particles'

const About = () => {
	useEffect(() => {
		document.title = `About | ${INFO.main.title}`;
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>
			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					{/* <div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div> */}
					<Particles />
					<div className="about-container">
						<div className="about-main" style={{marginBottom:"0px"}}>
							<div className="about-right-side">
								<div className="title about-title">
									{INFO.about.title}
								</div>

								<div className="subtitle about-subtitle">
									{INFO.about.description}
									<GitHubCalendar username="doctoey" style={{marginTop:"35px"}}/>
								</div>
								<div>
									<Works />
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg"
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer style={{ marginTop: 0 }} />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
